import React from 'react';

const NodeEditor = ({ addNode }) => {
  return (
    <div className="node-editor">
      <h5>Add Node</h5>
      <div className="add-node-controls">
        <button 
          className="add-node-btn"
          onClick={addNode}
        >
          ➕ Add Node
        </button>
        <p className="add-node-info">
          Click to add a new node to the graph. The node will be placed in the center with a random offset.
        </p>
      </div>
    </div>
  );
};

export default NodeEditor;
